// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  appVersion: 'v1.0.0',
  appName: "INSIGHT360",
  apiUrl: 'https://api.insight360.tech/api',
  storageUrl: 'https://api.insight360.tech/storage',
  pusherUrl: 'https://api.insight360.tech/broadcasting/auth',
  pusherKey: 'f900d9dd2f660b15ab96',
  pusherCluster: 'eu',
};
